import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, signal, WritableSignal, PLATFORM_ID, Inject, inject, computed } from '@angular/core';
import { ResolutionService } from '../resolution.service';

declare global {
  interface Window {
    Intercom: any;
  }
}

@Component({
  selector: 'app-intercom-custom-launcher',
  imports: [],
  templateUrl: './intercom-custom-launcher.component.html',
  styleUrl: './intercom-custom-launcher.component.scss'
})
export class IntercomCustomLauncherComponent implements OnInit {

  #resolutionService = inject(ResolutionService);

  isMessengerOpen: WritableSignal<boolean> = signal(false);

  isMobile = computed(() => this.#resolutionService.isMobile())

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!window.Intercom) return;
    window.Intercom('onHide', () => this.isMessengerOpen.set(false));
    window.Intercom('onShow', () => this.isMessengerOpen.set(true));
  }

}
